import { schema } from 'normalizr'

import { idAttribute, processStrategy } from 'modules/table'

const tableProduct = new schema.Entity(
  'tableProducts',
  {},
  {
    idAttribute,
    processStrategy,
  }
)

export default tableProduct
